var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { mdMenu, mdButton, mdIcon, mdContent, mdProgressSpinner, } from "vue-material";
import { switchTheme, isMobile } from "./../my-common/common-func";
var CompProps = Vue.extend({
    props: {
        slogan: String,
        switchPlaceA: { type: Function },
    },
});
// Register for components
var myHeader = /** @class */ (function (_super) {
    __extends(myHeader, _super);
    function myHeader() {
        var _this = _super.call(this) || this;
        _this.showAboutDialog = false;
        _this.optionsStyle = {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            paddingBottom: "10px",
            itemsAlign: "left",
            height: "650px",
            overflow: "scroll",
        };
        _this.windowGlobal = window;
        _this.switchTheme = switchTheme.bind(_this);
        return _this;
    }
    myHeader.prototype.data = function () {
        return {
            myData: "test",
            tyfetchVisibility: true,
            loginBtnVisibility: false,
            switchThemeBtnLabel: "Dark",
            isMobile: isMobile,
        };
    };
    myHeader.prototype.switchTheme = function () { };
    myHeader.prototype.changeTheme = function (themeEnu) {
        this.$set(this, "switchThemeBtnLabel", themeEnu);
    };
    myHeader.prototype.visibilityUsersComponent = function () {
        this.$root.$children[0].setUsersVisibility();
    };
    myHeader.prototype.mounted = function () {
        this.$root.$material.theming.theme = "Dark";
        this.$set(this, "tyfetchVisibility", false);
        this.$set(this, "loginBtnVisibility", true);
        this.$set(this, "switchThemeBtnLabel", "Dark");
    };
    myHeader.prototype.createPayPalDonateButton = function () {
        var root = this;
        var myPaypal = document.createElement("script");
        myPaypal.src =
            "https://www.paypal.com/sdk/js?client-id=AT1RiWCQ0vlgUA7ZC0Qnvu1p_pfqrD-AIYSRw0fAweI0FBJJgt1n4yiwhdxjEwMBWxaAIUFS8Ixu1vMc&currency=USD";
        myPaypal.setAttribute("data-sdk-integration-source", "button-factory");
        document.head.appendChild(myPaypal);
        myPaypal.onload = function () {
            root.windowGlobal.paypal
                .Buttons({
                style: {
                    shape: "rect",
                    color: "blue",
                    layout: "vertical",
                    label: "paypal",
                },
                createOrder: function (data, actions) {
                    return actions.order.create({
                        purchase_units: [
                            {
                                amount: {
                                    value: "20",
                                },
                            },
                        ],
                    });
                },
                onApprove: function (data, actions) {
                    return actions.order.capture().then(function (details) {
                        console.warn("Transaction completed by " +
                            details.payer.name.given_name +
                            "!");
                    });
                },
            })
                .render("#paypal-button-container");
        };
    };
    myHeader.prototype.showAboutDialogClick = function () {
        this.showAboutDialog = true;
        this.createPayPalDonateButton();
    };
    myHeader.prototype.showDownloadsComponent = function () {
        this.$root.$children[0].showDownloads();
    };
    myHeader.prototype.showAboutComponent = function () {
        this.$root.$children[0].showAbouts();
    };
    myHeader.prototype.showShooterFrame = function () {
        this.$root.$children[0].showAboutsAndShooterFrame();
    };
    myHeader = __decorate([
        Component({
            components: {
                mdButton: mdButton,
                mdMenu: mdMenu,
                mdIcon: mdIcon,
                mdProgressSpinner: mdProgressSpinner,
                mdContent: mdContent,
            },
        }),
        Component
    ], myHeader);
    return myHeader;
}(CompProps));
export default myHeader;
